var _desc, _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClicked(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "40px",
    viewBox: "0 0 25 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_clicked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send-A-Message-V5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "25-Control-Groups",
    transform: "translate(-753.000000, -495.000000)",
    fill: "#36424E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765.042872,533.159247 L761.768268,525.201034 L758.112961,529.326039 C756.314995,531.355104 753,530.061586 753,527.304708 L753,498.012562 C753,495.300528 756.234448,493.975448 758.062023,495.935216 L777.183322,516.438288 C778.956522,518.339462 777.657852,521.523451 775.058716,521.523451 L769.92513,521.523451 L773.269578,529.651352 C773.906218,531.198775 773.188719,532.972528 771.670049,533.605263 L768.857554,534.777217 C767.370368,535.396593 765.669433,534.682139 765.042872,533.159247 Z M762.555376,520.54345 L767.354978,532.208073 C767.447321,532.432839 767.676618,532.561043 767.896071,532.469558 L770.708488,531.297682 C770.951769,531.196275 771.068175,530.871509 770.95755,530.602681 L766.193105,519.023448 L775.058638,519.023448 C775.449965,519.023448 775.653949,518.464072 775.354965,518.14329 L756.233745,497.640218 C755.951949,497.338421 755.499996,497.568655 755.499996,498.012562 L755.499996,527.304708 C755.499996,527.75588 755.963667,527.982053 756.241948,527.66799 L762.555376,520.54345 Z",
    id: "ic_clicked"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicked);
export default __webpack_public_path__ + "static/media/clicked.7f65200685d9c31a682152cc26c07ffb.svg";
export { ForwardRef as ReactComponent };